<template>
    <div>
        <swiper :options="domainNavigationOptions" ref="domainNavigation" class="domain-navigation">
            <swiper-slide
                v-for="(nav, index) in navigationItems"
                :key="index"
                :class="{ 'domain-navigation__item--disabled': !nav.isActive }"
            >
                <template v-if="nav.isActive">
                    <template v-if="nav.manage_href">
                        <a
                                :href="nav.manage_href"
                                class="btn--domain-action"
                                :class="isNavActiveClass(nav)"
                                v-on="{
                            click: () => {
                                if (nav.click) {
                                    nav.click();
                                }
                            },
                        }"
                        >
                            <span class="icon-ccs" :class="nav.icon"></span><br /><span class="label-ccs">{{
                            nav.label
                        }}</span>
                        </a>
                    </template>
                    <template v-else>
                        <router-link
                                :to="nav.href"
                                class="btn--domain-action"
                                :class="isNavActiveClass(nav)"
                                v-on="{
                            click: () => {
                                if (nav.click) {
                                    nav.click();
                                }
                            },
                        }"
                        >
                            <span class="icon-ccs" :class="nav.icon"></span><br /><span class="label-ccs">{{
                            nav.label
                        }}</span>
                        </router-link>
                    </template>
                </template>
                <template v-else>
                    <span
                        class="btn--domain-action btn--domain-action--disabled"
                        :title="isMainDomain ? `No permissions` : `Not supported for Dev Env`"
                    >
                        <span class="icon-ccs" :class="nav.icon"></span><br /><span class="label-ccs">{{
                            nav.label
                        }}</span>
                    </span>
                </template>
            </swiper-slide>
            <span
                slot="button-prev"
                class="ccs-action ccs-action--force-visible ccs-action--next icon-next-ccs icon-ccs"
            ></span>
            <span
                slot="button-next"
                class="ccs-action ccs-action--force-visible ccs-action--prev icon-prev-ccs icon-ccs"
            ></span>
        </swiper>
        <navigation-ccs-modal></navigation-ccs-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import CcsModal from "@/components/CcsModal.vue";

export default {
    components: {
        Swiper,
        SwiperSlide,
        NavigationCcsModal: CcsModal,
    },

    directives: {
        swiper: directive,
    },

    props: {
        currentRoute: {
            type: String,
            default() {
                return null;
            },
        },
        propDomainId: {
            type: Number,
            default() {
                return 0;
            },
        },
        propRootDomainId: {
            type: Number,
            default() {
                return 0;
            },
        },
        propDomainLimitations: {
            type: Object,
            default() {
                return {};
            },
        },
    },

    data: function () {
        return {
            domainNavigationOptions: {
                slidesPerView: "auto",
                watchOverflow: true,
                navigation: {
                    nextEl: ".icon-next-ccs",
                    prevEl: ".icon-prev-ccs",
                    disabledClass: "ccs-action--force-invisible",
                },
                roundLengths: true,
            },
        };
    },

    computed: {
        ...mapState("environments", {
            envDomainId: (state) => parseInt(state.domainId),
            envRootDomainId: (state) => parseInt(state.rootDomainId),
            environments: "environments",
            domain_data: "domain_data",
        }),
        domainId() {
            if (this.propDomainId) {
                return this.propDomainId;
            }
            return this.envDomainId;
        },
        rootDomainId() {
            if (this.propRootDomainId) {
                return this.propRootDomainId;
            }
            return this.envRootDomainId;
        },
        isMainDomain() {
            return this.domainId === this.rootDomainId;
        },
        navigationItems() {
            //todo switch to router-view and remove a href + manage_href
            return [
                {
                    label: "Manage",
                    icon: "icon-manage-ccs",
                    // href: "/manager/domains/" + this.domainId,
                    href: this.$router.resolve({
                        name: "domains.manage.index",
                        params: {
                            domain_id: this.domainId,
                        },
                    }).resolved.path,
                    name: "domains.manage",
                    isActive: this.hasLimit("manage"),
                },
                {
                    label: "Emails",
                    icon: "icon-email-ccs",
                    // href: "/manager/domains/" + this.domainId + "/mails",
                    href: this.$router.resolve({
                        name: "domains.mails.index",
                        params: {
                            domain_id: this.domainId,
                        },
                    }).resolved.path,
                    name: "domains.mails",
                    isActive: this.hasLimit("emails"),
                },
                {
                    label: "Databases",
                    icon: "icon-database-ccs",
                    href: "/ui/domains/" + this.domainId + "/databases",
                    manage_href: "/ui/domains/" + this.domainId + "/databases",
                    name: "domains.databases",
                    isActive: this.hasLimit("databases"),
                },
                {
                    label: "Cronjobs",
                    icon: "icon-cron-ccs",
                    href: this.$router.resolve({
                        name: "domains.cronjobs.index",
                        params: {
                            domain_id: this.domainId,
                        },
                    }).resolved.path,
                    name: "domains.cronjobs",
                    isActive: this.hasLimit("cronjobs"),
                },
                {
                    label: "DNS",
                    icon: "icon-dns-ccs",
                    // href: "/manager/domains/" + this.domainId + "/dns",
                    href: this.$router.resolve({
                        name: "domains.dns.index",
                        params: {
                            domain_id: this.domainId,
                        },
                    }).resolved.path,
                    name: "domains.dns",
                    isActive: this.hasLimit("dns"),
                },
                {
                    label: "Backups",
                    icon: "icon-backup-ccs",
                    // href: "/manager/domains/" + this.domainId + "/backups/manage",
                    href: this.$router.resolve({
                        name: "domains.backups.index",
                        params: {
                            domain_id: this.domainId,
                        },
                    }).resolved.path,
                    name: "domains.backups",
                    isActive: this.hasLimit("backups"),
                },
                {
                    label: "SSL",
                    icon: "icon-ssl-ccs",
                    // href: "/manager/domains/" + this.domainId + "/ssl",
                    href: this.$router.resolve({
                        name: "domains.ssl.index",
                        params: {
                            domain_id: this.domainId,
                        },
                    }).resolved.path,
                    name: "domains.ssl",
                    isActive: this.hasLimit("ssl"),
                },
                {
                    label: "Logs",
                    icon: "icon-logs-ccs",
                    // href: "/manager/domains/" + this.domainId + "/logs",
                    href: this.$router.resolve({
                        name: "domains.logs",
                        params: {
                            domain_id: this.domainId,
                        },
                    }).resolved.path,
                    name: "domains.logs",
                    isActive: this.hasLimit("logs"),
                },
                {
                    label: "Dev Env",
                    icon: "icon-developer-env-ccs",
                    href: this.$router.resolve({
                        name: "domains.environments",
                        params: {
                            domain_id: this.domainId,
                        },
                    }).resolved.path,
                    name: "domains.environments",
                    isActive: this.hasLimit("dev_env"),
                },
                {
                    label: "Speed",
                    icon: "icon-speed-ccs",
                    href: "/manager/domains/" + this.domainId + "/speed",
                    manage_href: "/manager/domains/" + this.domainId + "/speed",
                    name: "",
                    isActive: this.hasLimit("speed"),
                },
                {
                    label: "Remove",
                    icon: "icon-delete-ccs",
                    href: "/manager/domains/" + this.domainId + "/remove",
                    manage_href: "/manager/domains/" + this.domainId + "/remove",
                    name: "",
                    isActive: this.hasLimit("remove"),
                    click: this.deleteDomain,
                },
            ];
        },
    },

    methods: {
        isNavActiveClass(nav) {
            return {
                "is-active":
                    this.$route.matched.some(({ name }) => name === nav.name)
            }
        },
        hasLimit(limitation) {
            if (
                this.propDomainLimitations.hasOwnProperty("buttons") &&
                this.propDomainLimitations.buttons.hasOwnProperty(limitation)
            ) {
                return this.propDomainLimitations.buttons[limitation];
            }

            return true;
        },
        // TODO we need to move this to vuex or a shared 'API' like setup.
        async deleteDomain() {
            if (this.domainId === this.rootDomainId) {
                window.location = this.$laroute.action("domain_remove_get", { domain_id: this.domainId });
            } else {
                let env_name = this.environments
                    .filter((c) => c.id === parseInt(this.domainId))
                    .map((c) => c.env_name)
                    .pop();

                let deleteRoute = this.$laroute.action("domain_delete", {
                    domain_id: this.domainId,
                });

                let payload = {
                    data: {
                        delete_domain: {
                            determine_state: "remove_all",
                        },
                    },
                };

                this.$modal.show("navigation-ccs-modal-dialog", {
                    title: "Are you sure?",
                    type: "error",
                    text: `Removing environment <strong>${env_name}</strong> can't be undone.`,
                    buttons: [
                        {
                            title: "Yes, delete it!",
                            class: "c-btn c-btn--error c-btn--primary",
                            handler: () => {
                                this.$axios.delete(deleteRoute, payload).then((response) => {
                                    if (response.data.status === "OK") {
                                        this.$store.dispatch("environments/deleteEnvironment", this.domainId);
                                        this.$modal.hide("navigation-ccs-modal-dialog");
                                        this.$notify({
                                            type: "success",
                                            title: "Dev Env removed",
                                        });
                                        this.$router.push({
                                            name: "domains.environments.manage",
                                            params: { domain_id: this.rootDomainId },
                                        });
                                    } else {
                                        this.$modal.hide("navigation-ccs-modal-dialog");
                                        this.$notify({
                                            type: "error",
                                            title: "Error!",
                                            text: response.data.message ? response.data.message : "",
                                        });
                                    }
                                });
                            },
                        },
                        {
                            title: "Close",
                            default: true, // Will be triggered by default if 'Enter' pressed.
                        },
                    ],
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.swiper-slide {
    width: 100px;
}

.icon-next-ccs,
.icon-prev-ccs {
    z-index: 10;
}
</style>
